// components/DoarModal.jsx
import { useEffect, useState } from 'react';

const PIX_CODE = '00020101021126590014br.gov.bcb.pix0119lagocvpix@gmail.com0214OFERTAS LAGOCV5204000053039865802BR5925IGREJA BATISTA DA LAGOINH6008BRASILIA62070503***630453C4';

const DoarModal = ({ isOpen, onClose }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
      setCopied(false);
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleCopy = () => {
    navigator.clipboard.writeText(PIX_CODE).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 px-4">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
        <button
          className="absolute top-3 right-4 text-gray-600 hover:text-gray-800 text-xl font-bold"
          onClick={onClose}
          aria-label="Fechar modal"
        >
          &times;
        </button>
        <h2 className="text-2xl font-semibold mb-4 text-center text-gray-800">Dízimos e ofertas</h2>

        <div className="text-center">
          <img src="/images/pix_lagoinha.jpg" alt="QR Code PIX Igreja" className="mx-auto w-100" />
        </div>

        <div className="mt-4">
          <p className="text-xs text-gray-500 text-center mb-2">Ou copie o código PIX abaixo</p>
          <div className="flex items-center gap-2 bg-gray-100 rounded-lg px-3 py-2">
            <span className="text-xs text-gray-600 truncate flex-1 font-mono select-all">
              {PIX_CODE}
            </span>
          </div>
          <button
            onClick={handleCopy}
            className={`mt-3 w-full py-2.5 rounded-lg text-sm font-bold transition-all duration-200 ${
              copied
                ? 'bg-green-500 text-white'
                : 'bg-yellow-500 hover:bg-yellow-400 text-gray-900'
            }`}
          >
            {copied ? '✓ Código copiado!' : 'Copiar código PIX'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DoarModal;
